(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("DocLogger", [], factory);
	else if(typeof exports === 'object')
		exports["DocLogger"] = factory();
	else
		root["DocLogger"] = factory();
})(window, function() {
return 